CollectionWithHelpers = require 'models/collections/internal/collection-with-helpers'
CustomField = require 'models/custom-field'

module.exports = class CustomFieldList extends CollectionWithHelpers
  model: CustomField

  initialize: ->
    @listenTo(@, 'change:pos', @sort)

  comparator: (customField) ->
    customField.get('pos')



// WEBPACK FOOTER //
// ./app/scripts/models/collections/custom-field-list.coffee